// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__35XMm","content":"GlobalSearch_content__1VIWz"};